import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import GroupProviderSwipe from '../components/Profile/GroupProviderSwipe';
import { GroupIntakeProvider } from '../components/GroupIntake/contexts/GroupIntakeRootContext';

// Provider swiping page that handles both URL formats:
// /group-provider-swipe (no listing ID)
// /group-provider-swipe/:listingId (listing ID in path)
const GroupProviderSwipePage = () => {
  const { auth } = useContext(AuthContext);
  const { listingId } = useParams(); // Extract listingId from URL path if present

  // Redirect to login if not authenticated
  if (!auth?.token) {
    return (
      <div className="text-center p-5">
        <p>Please login to view provider matches</p>
      </div>
    );
  }
  
  return (
    <GroupIntakeProvider>
      <GroupProviderSwipe pathListingId={listingId} />
    </GroupIntakeProvider>
  );
};

export default GroupProviderSwipePage;
